import { useContext, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { CartContext } from "../context/CartContext";
import cart_empty from "../resources/cart_empty.png";
import cart_full from "../resources/cart_full.png";
import cart_add from "../resources/cart_check.png";

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { cartCount, addTrigger } = useContext(CartContext);
    const [showAdd, setShowAdd] = useState(false);
    const [showCart, setShowCart] = useState(true);

    // Trigger +1 animation whenever addToCart is called (addTrigger changes)
    useEffect(() => {
        if (addTrigger > 0) {
            setShowAdd(true);
            setShowCart(false); // hide cart while +1 animation is visible
            const timer = setTimeout(() => {
                setShowAdd(false);
                setShowCart(true); // show cart again after animation
            }, 1200); // match animation duration
            return () => clearTimeout(timer);
        }
    }, [addTrigger]);

    // Hide cart icon on cart page and checkout page
    if (
        location.pathname === "/educations/cart" ||
        location.pathname === "/educations/checkout"
    )
        return null;

    if (cartCount === 0) return null;

    return (
        <div className='cart-floating'>
            {showAdd && (
                <img src={cart_add} alt='+1' className='cart-add-animation' />
            )}
            {showCart && (
                <img
                    src={cartCount > 0 ? cart_full : cart_empty}
                    alt='Cart'
                    className='cart-icon'
                    onClick={() => navigate("/educations/cart")}
                    style={{ cursor: "pointer" }}
                />
            )}
            {showCart && cartCount > 0 && (
                <span className='cart-badge'>{cartCount}</span>
            )}
        </div>
    );
};

export default Header;
